import React, { useState, useEffect } from 'react';
import {
    useLocation,
} from "react-router-dom";

function useQuery() {
    const query = new URLSearchParams(useLocation().search);
    return new URLSearchParams(useLocation().search);
}
export default function SetFavorites() {
  const query= useQuery()
  const favorites = query.get('favorites') ? `[${query.get('favorites')}]` : null;
  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    if(favorites) {
        localStorage.setItem('horses_K20D', favorites);
    }
});

  return (
    <></>
  );
}
